// extracted by css-extract-rspack-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_Svg","cls2":"CollapsedActivityPreview-cls2_Xi4 CollapsedActivityPreview-cls1_Svg"};